import { render, staticRenderFns } from "./ChildZoneBox.vue?vue&type=template&id=05f66529&scoped=true"
import script from "./ChildZoneBox.vue?vue&type=script&lang=js"
export * from "./ChildZoneBox.vue?vue&type=script&lang=js"
import style0 from "./ChildZoneBox.vue?vue&type=style&index=0&id=05f66529&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f66529",
  null
  
)

export default component.exports